import FileManagementControls from './FileManagementControls';
import {
  fileServiceUrlToID,
  checkIsFileServiceFile,
} from '../../services/FileService';

export { fileServiceUrlToID, checkIsFileServiceFile };

export default FileManagementControls;
